import { render, staticRenderFns } from "./Particulars.vue?vue&type=template&id=04bcc1c9&scoped=true&"
import script from "./Particulars.vue?vue&type=script&lang=js&"
export * from "./Particulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcc1c9",
  null
  
)

export default component.exports